module.exports = __webpack_public_path__ + "static/media/cover_face.5c05e9bd.jpg";